/**
 * Which assignedId the month edit popover should look its content up by.
 *
 * Saving a pre-save item replaces its row in place under a brand-new id, so the
 * temporary string id the popover opened with vanishes from the day's exercise
 * array. Resolving by the held id alone yields nothing, and the popover's
 * "the item I was editing disappeared" guard reads that as a delete and closes.
 *
 * Following the published swap here — during render, not in an effect — means
 * content resolves on the same commit the save lands on, so the popover is
 * never unmounted. An effect-only remap would drop it for a frame and it would
 * come back having lost its position and its description/info fields.
 *
 * @param {?Object} editingItem       `{ assignedId, … }`, or null when closed
 * @param {?Object} lastPreSaveIdSwap `{ from, to }` from calendar.data
 * @returns {?string|number} the id to resolve content by, or null
 */
const resolveEditingAssignedId = (editingItem, lastPreSaveIdSwap) => {
  if (!editingItem) return null;
  if (lastPreSaveIdSwap && lastPreSaveIdSwap.from === editingItem.assignedId) {
    return lastPreSaveIdSwap.to;
  }
  return editingItem.assignedId;
};

export default resolveEditingAssignedId;
